'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import Small from 'UIComponents/elements/Small';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LEARN_MORE_URL = 'https://blog.hubspot.com/marketing/am-guide-accelerated-mobile-pages';
class PublishingAmpEnabler extends Component {
  render() {
    const {
      ampEnabled,
      contentGroupId,
      contentType,
      disabled,
      onToggleAmpEnabled,
      shouldShow
    } = this.props;
    const editUrl = contentGroupId ? ContentRoutes.blogSpecificSettings(contentGroupId) : ContentRoutes.settings('blog');
    if (shouldShow) {
      return /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publishingOptions.amp.heading"
          }),
          children: /*#__PURE__*/_jsxs(UICheckbox, {
            className: "m-top-4",
            checked: ampEnabled,
            onChange: onToggleAmpEnabled,
            readOnly: disabled,
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `publishingOptions.amp.checkbox.${contentType}`
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Small, {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "publishingOptions.amp.description"
              }), "\xA0", /*#__PURE__*/_jsx(UILink, {
                href: LEARN_MORE_URL,
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "publishingOptions.amp.learnMore"
                })
              }), "."]
            })]
          })
        }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
          width: "150px",
          children: /*#__PURE__*/_jsx(UIButton, {
            href: editUrl,
            block: true,
            use: "tertiary-light",
            size: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "publishingOptions.amp.manage"
            })
          })
        })]
      });
    }
    return null;
  }
}
PublishingAmpEnabler.propTypes = {
  ampEnabled: PropTypes.bool.isRequired,
  contentGroupId: PropTypes.number,
  contentType: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onToggleAmpEnabled: PropTypes.func.isRequired,
  shouldShow: PropTypes.bool.isRequired
};
PublishingAmpEnabler.defaultProps = {
  ampEnabled: false
};
export default PublishingAmpEnabler;